module.exports = "/assets/data/1be8b5f78f3809552b9f7dd615616265-B63.data.json";